import React, { useState, useEffect } from 'react';

export default ({ activeFilters = [], setActiveFilters = (_ = []) => { }, filters = [] }) => {
    const [selectedFilter, setSelectedFilter] = useState('all');

    useEffect(() => {
        if (selectedFilter === 'all') {
            setActiveFilters([]);
        } else {
            setActiveFilters([selectedFilter]);
        }
    }, [selectedFilter, setActiveFilters]);

    const handleFilterChange = (e) => {
        setSelectedFilter(e.target.value);
        setTimeout(() => {
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }
        }, 0);
    };

    const selectedFilterDisplay = selectedFilter === 'all' ? 'All' : filters.find(filter => filter.value === selectedFilter)?.display || '';

    return (
        <div>
            <select
                value={selectedFilter}
                onChange={handleFilterChange}
                className={`tw-text-[18px] tw-font-sans ${selectedFilter ? 'tw-font-semibold' : 'tw-font-light'} tw-text-text tw-w-full tw-py-2`}
            >
                <option value={selectedFilter} disabled style={{ display: 'none', paddingLeft: '10px' }}>
                    Content Type: {selectedFilterDisplay}
                </option>
                <option value="all">All</option>
                {filters.map((filter) => (
                    <option key={filter.value} value={filter.value}>
                        {filter.display}
                    </option>
                ))}
            </select>
        </div>
    );
};